import { useState, useEffect, useCallback } from "react";

const reviews = [
  {
    name: "Brenda Muter",
    rating: 5,
    date: "18 weeks ago",
    text: "Best transaction ever! Awesome treatment and product! I won't buy from anyone else! Thank you Corey!",
    avatar: "BM",
  },
  {
    name: "Patrick Hund",
    rating: 5,
    date: "20 weeks ago",
    text: "Absolutely the best service ever. Ordered yesterday and got it delivered today. Arrived even earlier. It saved my money — highly recommend!",
    avatar: "PH",
  },
  {
    name: "Marysol Blomerus",
    rating: 5,
    date: "45 weeks ago",
    text: "I found them through FB marketplace. They had exactly what I needed in stock. I arrived and was loaded up with everything I needed. Great experience!",
    avatar: "MB",
  },
  {
    name: "mariamar masso",
    rating: 5,
    date: "Nov 25, 2024",
    text: "I am so happy with the service, professionalism and knowledge I received from Corey. I knew nothing about insulation and he walked me through everything. Highly recommend!",
    avatar: "MM",
  },
  {
    name: "Russ Goggans",
    rating: 5,
    date: "Sep 16, 2024",
    text: "Huge savings on tons of tools, home supply items, home repair, you name it. I could have stayed all day and spent 4x what I did. Anxious to go back and find more great deals.",
    avatar: "RG",
  },
  {
    name: "Osman Dillard",
    rating: 5,
    date: "Sep 14, 2024",
    text: "Excellent service and good deals. Very happy with my purchase and will definitely be coming back!",
    avatar: "OD",
  },
  {
    name: "Sylvan Nedd",
    rating: 5,
    date: "Sep 14, 2024",
    text: "They have everything at a very reasonable price. Many ways to pay and a big variety of items!",
    avatar: "SN",
  },
  {
    name: "Daniel Barrett",
    rating: 5,
    date: "Sep 13, 2024",
    text: "Very well organized items, easy to find what you are looking for and amazing prices that are hard to beat. Highly recommended if you're near here to stop and shop!",
    avatar: "DB",
  },
  {
    name: "amber hamrick",
    rating: 5,
    date: "Sep 13, 2024",
    text: "Awesome deals and very friendly. Great place to shop!",
    avatar: "AH",
  },
  {
    name: "Aaron Orr",
    rating: 5,
    date: "Sep 13, 2024",
    text: "Great variety with amazing deals and the people are very nice to work with.",
    avatar: "AO",
  },
  {
    name: "Kasandra Gomez",
    rating: 5,
    date: "Sep 13, 2024",
    text: "The staff was friendly and outgoing. They have a variety of things at really good prices. They are honest about their things!",
    avatar: "KG",
  },
  {
    name: "Susan Greeson",
    rating: 5,
    date: "Sep 13, 2024",
    text: "Wonderful place to shop. Great prices.",
    avatar: "SG",
  },
  {
    name: "William Chang",
    rating: 5,
    date: "Sep 13, 2024",
    text: "Great deals and awesome products! Highly recommended and will be back.",
    avatar: "WC",
  },
  {
    name: "Eddie Willis",
    rating: 5,
    date: "Sep 13, 2024",
    text: "Great stuff and prices. Very happy with everything I picked up!",
    avatar: "EW",
  },
  {
    name: "larry edge",
    rating: 5,
    date: "Jul 29, 2024",
    text: "This is a great place to buy your insulation. Reasonable prices and he actually messages you back.",
    avatar: "LE",
  },
  {
    name: "Phillip Parnell",
    rating: 5,
    date: "May 3, 2024",
    text: "I highly recommend this seller. Quality of his insulation was exactly as described. Very professional and quick to respond with information. Will definitely do more business with them.",
    avatar: "PP",
  },
  {
    name: "Andrew Bridges",
    rating: 5,
    date: "Apr 8, 2024",
    text: "Bought some insulation for a metal building we had built, found Corey selling the 2\" thick foam boards and contacted him. Great experience from start to finish!",
    avatar: "AB",
  },
  {
    name: "Conjunto Cascabel de AGS",
    rating: 5,
    date: "Mar 23, 2024",
    text: "Good service.",
    avatar: "CC",
  },
];

export default function ReviewsCarousel() {
  const [current, setCurrent] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const visibleCount = 3;
  const total = reviews.length;

  const goTo = useCallback(
    (index: number) => {
      if (isAnimating) return;
      setIsAnimating(true);
      setCurrent((index + total) % total);
      setTimeout(() => setIsAnimating(false), 400);
    },
    [isAnimating, total]
  );

  const prev = () => goTo(current - 1);
  const next = () => goTo(current + 1);

  useEffect(() => {
    const timer = setInterval(() => {
      goTo(current + 1);
    }, 4500);
    return () => clearInterval(timer);
  }, [current, goTo]);

  const getVisible = () => {
    const items = [];
    for (let i = 0; i < visibleCount; i++) {
      items.push(reviews[(current + i) % total]);
    }
    return items;
  };

  const stars = (count: number) =>
    Array.from({ length: 5 }, (_, i) => (
      <i
        key={i}
        className={`${i < count ? "ri-star-fill" : "ri-star-line"} text-yellow-400 text-sm`}
      ></i>
    ));

  return (
    <section className="w-full py-14 px-4" style={{ background: "#f9f9f9" }}>
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex flex-col sm:flex-row items-center justify-between mb-10 gap-4">
          <div>
            <div className="flex items-center gap-2 mb-1">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-google-fill text-red-500 text-lg"></i>
              </div>
              <span className="text-xs font-black uppercase tracking-widest text-gray-400">
                Google Reviews
              </span>
            </div>
            <h2 className="text-2xl md:text-3xl font-black text-gray-900 leading-tight">
              What Our Customers Say
            </h2>
            <div className="flex items-center gap-2 mt-2">
              <div className="flex items-center gap-0.5">
                {stars(5)}
              </div>
              <span className="text-sm font-bold text-gray-600">
                5.0 &nbsp;·&nbsp; Google Reviews
              </span>
            </div>
          </div>

          {/* Nav arrows */}
          <div className="flex items-center gap-3">
            <button
              onClick={prev}
              className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-gray-200 hover:border-red-500 hover:text-red-500 text-gray-400 transition-colors cursor-pointer"
              aria-label="Previous review"
            >
              <i className="ri-arrow-left-s-line text-xl"></i>
            </button>
            <button
              onClick={next}
              className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-gray-200 hover:border-red-500 hover:text-red-500 text-gray-400 transition-colors cursor-pointer"
              aria-label="Next review"
            >
              <i className="ri-arrow-right-s-line text-xl"></i>
            </button>
          </div>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {getVisible().map((review, idx) => (
            <div
              key={`${review.name}-${idx}`}
              className="bg-white rounded-xl p-6 border border-gray-100 flex flex-col gap-4 transition-opacity duration-400"
              style={{ opacity: isAnimating ? 0.6 : 1 }}
            >
              {/* Stars */}
              <div className="flex items-center gap-0.5">{stars(review.rating)}</div>

              {/* Text */}
              <p className="text-gray-600 text-sm leading-relaxed flex-1">
                &ldquo;{review.text}&rdquo;
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-2 border-t border-gray-50">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-red-600 text-white text-xs font-black flex-shrink-0">
                  {review.avatar}
                </div>
                <div>
                  <p className="text-sm font-bold text-gray-900">{review.name}</p>
                  <p className="text-xs text-gray-400">{review.date}</p>
                </div>
                <div className="ml-auto w-5 h-5 flex items-center justify-center">
                  <i className="ri-google-fill text-gray-300 text-base"></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-8">
          {reviews.map((_, i) => (
            <button
              key={i}
              onClick={() => goTo(i)}
              className={`rounded-full transition-all cursor-pointer ${
                i === current
                  ? "w-6 h-2 bg-red-500"
                  : "w-2 h-2 bg-gray-300 hover:bg-gray-400"
              }`}
              aria-label={`Go to review ${i + 1}`}
            />
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-8">
          <a
            href="https://share.google/Tr41mVFzwkGEVo2aq"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-gray-400 hover:text-red-500 transition-colors cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-external-link-line text-sm"></i>
            </div>
            Read all reviews on Google
          </a>
        </div>
      </div>
    </section>
  );
}
